
import { CustomerSettingsService, SystemConfiguration } from "@nt-portal/server-sdk";
import { BaseClientService } from "../base-client.service";


export class ClientSystemSettingsService extends BaseClientService {

    private _service: CustomerSettingsService;

    constructor() {
        super();
        this._service = new CustomerSettingsService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


    public async getClientSettings() {
        return await this._service.getClient(this.token);
    }

    public async get() {
        return await this._service.get(this.token);
    }

    public async save(item: SystemConfiguration) {
        return await this._service.add(item, this.token,);
    }

    public async update(setting: SystemConfiguration) {
        return await this._service.update(setting, this.token);
    }

}